"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGameTerm = void 0;
const LanguageCode_1 = require("../../enums/game/LanguageCode");
const flarieTermText = `The game is hosted and technically provided by Flarie and is free of charge. By 
playing the game you acknowledge that you have read and accept Flarie's <a href="https://flarie.com/terms" target="_blank">Terms
& Conditions</a>, <a href="https://flarie.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://flarie.com/cookies" target="_blank">Cookie Policy</a>. 

The Flarie partner that is the creator of this game is fully responsible for all text,
images, communication and any other relevant responsibilities connected to the 
game.

For any questions, please send an email to contact@flarie.com.`;
const organizationTermText = `{organisationName}, {streetAddress}, {zipCode}, {city}, {country} is the sender of this game and is responsible for all images, text, urls and content related to the game.{organisationName} processes your data according to their Privacy Policy. 
By playing the game you acknowledge that you have read the <a href="{privacyPolicyUrl}" target="_blank">Privacy Policy</a>.

For questions related to the game or how the company store and treats your data, contact {organisationName} at {brandContactEmail}.`;
exports.defaultGameTerm = {
    language: LanguageCode_1.LanguageCode.English,
    logoUrl: 'https://dwfedcf5lscmq.cloudfront.net/studio/60706eb9d459b.png',
    flarieTermText: flarieTermText,
    buttonText: 'Learn more about Flarie',
    buttonUrl: 'https://flarie.com/',
    organizationTermText: organizationTermText,
    termsAndConditionsText: 'By starting the game you accept our Terms & Conditions',
    termsButtonText: 'Flarie Game ® By playing the game you accept these Terms & Policies',
};
